import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  placeholder: {
    default: 'Search for an England footballer ...',
    editor: 'textbox',
  },
  delay: {
    default: '',
    editor: 'number',
  },
  borderless: {
    default: true,
    editor: 'checkbox',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  noItemsMessage: {
    default: 'Footballer not found ...',
    editor: 'textbox',
  },
  clearButton: {
    default: false,
    editor: 'checkbox',
  },
};

const AppSearchStory: Story = {
  title: 'Playground',
  description: 'An search where you can change all the attributes',
  coreComponent: {
    html: `<tag-card version="2">
  <tag-app-header heading='England Footballers' icon='Search' accent='dolphinblue'>
    <div slot='menu'>
      <tag-menu-item name="remove" icon='Delete' text='Remove'></tag-menu-item>
    </div>
  </tag-app-header>
  <tag-search{{...knobs}}>
    <tag-list
      left-icon='Star'
      primary-field='name'
      left-label-1='Age' left-field-1='age'>
    </tag-list>
  </tag-search>
</tag-card>`,
    js: `var players = [
  { number: 1, name: 'Jordan Pickford' },
  { number: 2, name: 'Kyle Walker' },
  { number: 5, name: 'John Stones' },
  { number: 6, name: 'Harry Maguire' },
  { number: 7, name: 'Luke Shaw' },
  { number: 8, name: 'Jordan Henderson' },
  { number: 9, name: 'Harry Kane' },
  { number: 10, name: 'Raheem Sterling' },
  { number: 12, name: 'Kieran Trippier' },
  { number: 18, name: 'Mason Mount' },
  { number: 20, name: 'Phil Foden' },
];
var search = document.querySelector('tag-search');
search.componentOnReady().then(function() {
  search.addEventListener('search', function(e) {
    var criteria = e.detail.criteria;
    var filteredPlayers = players.filter(function(player) {
      return player.name.toLowerCase().indexOf(criteria.toLowerCase()) > -1;
    });
    search.setData(filteredPlayers);
  });
});
var list = document.querySelector('tag-list');
list.componentOnReady().then(function() {
  list.setData(players);
});`,
    knobs: PlaygroundKnobs,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const players = [
      { number: 1, name: 'Jordan Pickford' },
      { number: 2, name: 'Kyle Walker' },
      { number: 5, name: 'John Stones' },
      { number: 6, name: 'Harry Maguire' },
      { number: 7, name: 'Luke Shaw' },
      { number: 8, name: 'Jordan Henderson' },
      { number: 9, name: 'Harry Kane' },
      { number: 10, name: 'Raheem Sterling' },
      { number: 12, name: 'Kieran Trippier' },
      { number: 18, name: 'Mason Mount' },
      { number: 20, name: 'Phil Foden' },
    ];
    const [criteria, setCriteria] = React.useState('');
    const data = players.filter(player => player.name.toLowerCase().indexOf(criteria.toLowerCase()) > -1);
    return (
      <TagCard version="2">
        <TagAppHeader
          heading='England Footballers'
          icon='Search'
          accent='dolphinblue'
          menuItems={[{
            icon: 'Delete',
            name: 'remove',
            text: 'Remove',
          }]}
        />
        <TagSearch{{...knobs}}
          data={data}
          onSearch={e => setCriteria(e.detail.criteria)}
        >
          <TagList
            leftIcon='Star'
            primaryField='name'
            leftLabel1='Age' leftField1='age'
          />
        </TagSearch>
      </TagCard>
    )
  }`,
    knobs: PlaygroundKnobs,
  },
};
export const TagSearchDocs: Component = {
  type: 'component',
  name: 'search',
  description:
    'Wraps the tag-searchbox. Pushes search results down to child components such as tag-list, tag-record and tag-table',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'placeholder',
      description: 'The placeholder on the search input',
      type: 'string',
      default: 'Search for records...',
    },
    {
      name: 'delay',
      description:
        'The delay in milliseconds after the user stops typing before the search is invoked',
      type: 'number',
      default: '500',
    },
    {
      name: 'borderless',
      description: 'When present it removes the border',
      type: 'boolean',
    },
    {
      name: 'disabled',
      description: 'Whether the control is disabled',
      type: 'boolean',
    },
    {
      name: 'clearButton',
      description: 'The boolean which tells us if the clear button does exist',
      type: 'boolean',
    },
    {
      name: 'noItemsMessage',
      default: 'No items to display',
      description: 'The messsage to be displayed if the search returns no items',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'search',
      description: 'Event raised when the search is invoked',
      parameters: [
        {
          name: 'criteria',
          description: 'The search criteria',
          type: 'string',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'getSearch',
      description: 'Gets the search criteria',
      parameters: [],
      returnType: 'string',
    },
    {
      name: 'setSearch',
      description: 'Sets the search criteria on the search input',
      parameters: [
        {
          name: 'search',
          description: 'The criteria to set',
          type: 'string',
        },
        {
          name: 'suppressSearch',
          description: 'Whether the search event is suppressed',
          type: 'boolean',
          default: 'false',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'setData',
      description: 'Sets the data and paging information for this component',
      parameters: [
        {
          name: 'data',
          description: 'The data to bind to the component',
          type: 'IPagedData | any[]',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'focusEditor',
      description: 'Set focus to the search editor text box',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [AppSearchStory],
};
